import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ESTADOS, hhmm } from "./statusHelper";

const punto = (geo, campo) => (geo ? `${geo.geofence_name ?? "-"} · ${hhmm(geo[campo])}` : "—");

const SalidaDetailModal = ({ unit, onClose }) => {
  const est = unit ? ESTADOS[unit.estado] : null;
  const salida = unit?.salida;

  return (
    <Modal isOpen={!!unit} toggle={onClose} centered>
      {unit && (
        <>
          <ModalHeader toggle={onClose}>
            <div className="d-flex align-items-center" style={{ gap: 12 }}>
              <div
                style={{
                  width: 44,
                  height: 44,
                  flex: "none",
                  borderRadius: "50%",
                  background: est.color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: unit.numero.length > 3 ? "12px" : "16px",
                  fontWeight: 700,
                  color: "#1b2431",
                }}
              >
                {unit.numero}
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: "15px", fontWeight: 600, lineHeight: 1.2 }}>Unidad {salida?.unit_name ?? unit.numero}</div>
                <div style={{ fontSize: "11.5px", color: "#777a89", fontWeight: 400, marginTop: 2 }}>
                  Ramal {salida?.ramal_nombre ?? unit.ramal}
                </div>
              </div>
            </div>
          </ModalHeader>

          <ModalBody>
            <div style={{ paddingBottom: 14, borderBottom: "1px solid #eff2f7" }}>
              <div className="d-flex align-items-baseline" style={{ gap: 8 }}>
                <span style={{ fontSize: "30px", fontWeight: 600, lineHeight: 1, color: est.ink }}>
                  {unit.desv == null ? "—" : unit.desv > 0 ? `+${unit.desv}` : unit.desv}
                </span>
                <span style={{ fontSize: "12px", color: "#777a89" }}>min respecto a su horario</span>
              </div>
              <div
                style={{
                  marginTop: 8,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  padding: "4px 11px",
                  borderRadius: 100,
                  background: est.bg,
                  border: `1px solid ${est.bd}`,
                  fontSize: "11.5px",
                  fontWeight: 600,
                  color: "#272a3a",
                }}
              >
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: est.color }} />
                {est.label}
              </div>
              {unit.ultimo && (
                <div style={{ fontSize: "11px", color: "#777a89", marginTop: 6 }}>Tolerancia del punto: {unit.tolerancia} min</div>
              )}
            </div>

            <div
              style={{
                paddingTop: 14,
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                rowGap: 10,
                columnGap: 14,
                fontSize: "12px",
              }}
            >
              <span style={{ color: "#777a89" }}>Operador</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>{salida?.operator_name ?? "—"}</span>
              <span style={{ color: "#777a89" }}>Salida programada</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>{hhmm(salida?.date)}</span>
              <span style={{ color: "#777a89" }}>Salida real</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>{hhmm(unit.real)}</span>
              <span style={{ color: "#777a89" }}>Último punto</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>{punto(unit.ultimo, "tiempo_real")}</span>
              <span style={{ color: "#777a89" }}>Siguiente punto</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>{punto(unit.siguiente, "tiempo_propuesto")}</span>
              <span style={{ color: "#777a89" }}>Avance</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>
                {unit.percent != null ? `${Math.round(unit.percent)}% del recorrido` : "Sin ubicación"}
              </span>
              <span style={{ color: "#777a89" }}>Puntos quemados</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>
                {unit.quemadas} · {salida?.min_quemados ?? 0} min acumulados
              </span>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button color="light" onClick={onClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default SalidaDetailModal;
